import { TranslationKeys } from '../index';

export const en: TranslationKeys = {
  betBuilder: {
    title: 'Bet Builder',
    noBetsSelected: 'Bet Builder is empty',
    addSelections: 'Add selections',
    totalOdds: 'Total Odds',
    totalSelections: 'Total Selections',
    clearAll: 'Clear All',
    removeBet: 'Remove bet',
    addBet: 'Add bet',
    event: 'Event',
    market: 'Market',
    selection: 'Selection',
    odds: 'Odds',
    confirmClear: 'Clear All Bets',
    confirmClearMessage: 'Are you sure you want to remove all bets? This action cannot be undone.',
    cancel: 'Cancel',
    confirm: 'Clear All',
    closed: 'Closed',
    suspend: 'Suspended',
    eventClosed: 'Closed',
    eventSuspended: 'Suspended',
    buildABet:'Bet Builder'
  },
  betStatus: {
    won: 'Won',
    pending: 'Pending',
    refund: 'Refund',
    lost: 'Lost',
    halfwon: 'Half Won',
    halflost: 'Half Lost',
    cashout: 'Cashout',
    unknown: 'Unknown'
  },
  common: {
    loading: 'Loading...',
    error: 'Error',
    retry: 'Retry',
    close: 'Close',
    save: 'Save',
    edit: 'Edit',
    delete: 'Delete',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    search: 'Search',
    filter: 'Filter',
    sort: 'Sort',
    settings: 'Settings'
  },
  errors: {
    generic: 'Something went wrong. Please try again.',
    network: 'Network error. Please check your connection.',
    notFound: 'The requested resource was not found.',
    unauthorized: 'You are not authorized to perform this action.',
    validation: 'Please check your input and try again.'
  }
};
